import { ref, watch, onActivated } from 'vue'
import { getToConvertTask, getOtherTask, getCycleFollowTask } from '@/api/overseasSales/index'
import type { AnalysisType } from '@/types/index'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'

interface TaskData {
  title: string
  secondData: string | number
  firstData: string | number
}
export default function taskSetting(formState: AnalysisType) {
  const { t } = useI18n()
  const followTask = ref<TaskData[]>()
  const readyChangeTask = ref<TaskData[]>()
  const otherTask = ref<TaskData[]>()
  const getOtherTaskList = async () => {
    try {
      const resOtherTask: any = await getOtherTask({
        depCode: formState.otherTask?.depCode,
        startDate: formState.otherTask?.startTime
          ? dayjs(formState.otherTask?.startTime).format('YYYY/MM/DD')
          : formState.otherTask?.startTime,
        endDate: formState.otherTask?.endTime
          ? dayjs(formState.otherTask?.endTime).format('YYYY/MM/DD')
          : formState.otherTask?.endTime
      })
      otherTask.value = [
        {
          title: t('home.8lcp4n'),
          secondData: resOtherTask.data.clueFutureTotal,
          firstData: resOtherTask.data.clueFuture
        },
        {
          title: t('home.iawmt6'),
          secondData: resOtherTask.data.visitPlanTotal,
          firstData: resOtherTask.data.visitPlan
        }
      ]
    } catch (error) {
      otherTask.value = [
        {
          title: t('home.8lcp4n'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.iawmt6'),
          secondData: 0,
          firstData: 0
        }
      ]
      console.log('error: ', error)
    }
  }
  const getToConvertTaskList = async () => {
    try {
      const res: any = await getToConvertTask({
        depCode: formState.toConvertTask?.depCode,
        month: dayjs(formState.toConvertTask?.month).format('YYYY/MM/DD')
      })

      readyChangeTask.value = [
        {
          title: t('home.vl5hrf'),
          secondData: res.data.newClueNumTarget,
          firstData: res.data.newClueNum
        },
        {
          title: t('home.bf48nh'),
          secondData: res.data.newPotentialCustomerNumTarget,
          firstData: res.data.newPotentialCustomerNum
        },
        {
          title: t('home.ndhk1u'),
          secondData: res.data.newContractCustomerNumTarget,
          firstData: res.data.newContractCustomerNum
        },
        {
          title: t('home.0kmlqb'),
          secondData: res.data.newDealCustomerNumTarget,
          firstData: res.data.newDealCustomerNum
        }
        // {
        //   title: t('home.ymqlzr'),
        //   secondData: res.data.oldDealCustomerNewAmountTarget,
        //   firstData: res.data.oldDealCustomerNewAmount
        // }
      ]
    } catch (error) {
      console.log('error: ', error)
      readyChangeTask.value = [
        {
          title: t('home.vl5hrf'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.bf48nh'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.ndhk1u'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.0kmlqb'),
          secondData: 0,
          firstData: 0
        }
        // {
        //   title: t('home.ymqlzr'),
        //   secondData: 0,
        //   firstData: 0
        // }
      ]
    }
  }
  const getCycleFollowTaskList = async () => {
    try {
      const resToConvertTask: any = await getCycleFollowTask({
        depCode: formState.cycleFollowTask?.depCode
      })
      followTask.value = [
        {
          title: t('home.v74rdm'),
          secondData: resToConvertTask.data.saleClueFirstTotal,
          firstData: resToConvertTask.data.saleClueFirst
        },
        {
          title: t('home.ttb8qm'),
          secondData: resToConvertTask.data.saleClueCycleTotal,
          firstData: resToConvertTask.data.saleClueCycle
        },
        {
          title: t('home.ffp4rd'),
          secondData: resToConvertTask.data.potentialNegotiationTotal,
          firstData: resToConvertTask.data.potentialNegotiation
        },
        {
          title: t('home.pmdlgn'),
          secondData: resToConvertTask.data.potentialShelvedTotal,
          firstData: resToConvertTask.data.potentialShelved
        },
        {
          title: t('home.y27rrw'),
          secondData: resToConvertTask.data.contractDockingTotal,
          firstData: resToConvertTask.data.contractDocking
        },
        {
          title: t('home.4v2g48'),
          secondData: resToConvertTask.data.contractPauseTotal,
          firstData: resToConvertTask.data.contractPause
        },
        {
          title: t('home.4hk1xo'),
          secondData: resToConvertTask.data.dealOneTotal,
          firstData: resToConvertTask.data.dealOne
        },
        {
          title: t('home.uaqikg'),
          secondData: resToConvertTask.data.dealTwoTotal,
          firstData: resToConvertTask.data.dealTwo
        },
        {
          title: t('home.66lwnj'),
          secondData: resToConvertTask.data.dealThreeTotal,
          firstData: resToConvertTask.data.dealThree
        },
        {
          title: t('home.qubyt2'),
          secondData: resToConvertTask.data.dealFourTotal,
          firstData: resToConvertTask.data.dealFour
        }
      ]
    } catch (error) {
      followTask.value = [
        {
          title: t('home.v74rdm'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.ttb8qm'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.ffp4rd'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.pmdlgn'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.y27rrw'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.4v2g48'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.4hk1xo'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.uaqikg'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.66lwnj'),
          secondData: 0,
          firstData: 0
        },
        {
          title: t('home.qubyt2'),
          secondData: 0,
          firstData: 0
        }
      ]

      console.log('error: ', error)
    }
  }
  watch(
    () => formState.cycleFollowTask,
    () => {
      getCycleFollowTaskList()
    },
    { deep: true, immediate: true }
  )
  watch(
    () => formState.toConvertTask,
    () => {
      getToConvertTaskList()
    },
    { deep: true, immediate: true }
  )
  watch(
    () => formState.otherTask,
    () => {
      getOtherTaskList()
    },
    { deep: true, immediate: true }
  )
  onActivated(() => {
    // getOtherTaskList()
    getToConvertTaskList()
    // getCycleFollowTaskList()
  })
  // onMounted(() => {
  //   getOtherTaskList()
  //   getCycleFollowTaskList()
  //   getToConvertTaskList()
  // })
  return { followTask, readyChangeTask, otherTask, getToConvertTaskList }
}
